import defaultState from "./state";

const Reducer = (state = defaultState, action) => {
  switch (action.type) {
    case "LOADING_APERTURAS_SCHEDULER": {
      return Object.assign({}, state, {
        isLoading: action.isLoading,
      });
    }
    case "LOADING_APERTURA_MODAL_WIZARD": {
      return Object.assign({}, state, {
        isModalWizardLoading: action.isModalWizardLoading,
      });
    }
    case "OPEN_CLOSE_MODAL_CONFLICT_WEEK": {
      return Object.assign({}, state, {
        isOpenModalConflictWeek: action.isOpen,
        isOpenModalEditWeek: false,
      });
    }
    case "SET_FERIADOS_ADMIN_APERTURAS": {
      return Object.assign({}, state, {
        feriadosAdministrativos: action.feriados,
      });
    }
    case "SET_CENTER_CONFIG_OPENING": {
      return Object.assign({}, state, {
        centerConfig: action.config,
      });
    }
    case "OPEN_CLOSE_MODAL_DELETE_OPENING": {
      return Object.assign({}, state, {
        isOpenModalDeleteOpening: action.isOpen,
        idOpeningToDelete: action.id,
      });
    }
    case "SET_CENTER_ID_OPENING": {
      return Object.assign({}, state, {
        centerId: action.centerId,
      });
    }
    case "SET_APPOINTMENT_OPENINGS_LIST": {
      return Object.assign({}, state, {
        listaAppointments: action.list,
      });
    }
    case "SET_LIST_WORKING_DAYS": {
      return Object.assign({}, state, {
        listDaysWorking: action.listDaysWorking,
      });
    }
    case "SET_CENTER_LIST": {
      return Object.assign({}, state, {
        centrosList: action.centrosList,
      });
    }
    case "SET_CONFIGURATION": {
      return Object.assign({}, state, {
        configList: action.list,
      });
    }
    case "SET_LIST_EXAM_POOL": {
      return Object.assign({}, state, {
        listExamPools: action.listExamPools,
      });
    }
    case "SET_LIST_EXAMS": {
      return Object.assign({}, state, {
        listExams: action.listExams,
      });
    }
    case "SET_LIST_EXAMS_CIEL": {
      return Object.assign({}, state, {
        listCiel: action.listCiel,
      });
    }
    case "SET_HIDE_SHOW_WIZARD": {
      return Object.assign({}, state, {
        isPopupWizardOpen: action.isPopupWizardOpen,
      });
    }
    case "SET_STEPS_WIZARD": {
      return Object.assign({}, state, {
        steps: action.steps,
      });
    }
    case "SET_OPENING": {
      return Object.assign({}, state, {
        Opening: action.Opening,
      });
    }
    case "SET_APPOINTMENT": {
      return Object.assign({}, state, {
        appointment: action.data,
      });
    }
    case "OPEN_CLOSE_MODAL_EDIT_WEEK": {
      return Object.assign({}, state, {
        isOpenModalEditWeek: action.isOpen,
        appointmentEditWeek: action.data,
      });
    }
    case "SET_APPOINTMENT_EDIT_WEEK": {
      return Object.assign({}, state, {
        appointmentEditWeek: action.data,
      });
    }
    case "SET_WEEK_APPOINTMENTS": {
      return Object.assign({}, state, {
        weekAppointments: action.list,
      });
    }
    case "SET_CONFIG_SCHEDULER_WIZARD": {
      return Object.assign({}, state, {
        configSchedulerWizard: action.configSchedulerWizard,
      });
    }
    case "RESET_OPENING_STATE": {
      return Object.assign({}, state, {
        Opening: {
          Id: 0,
          IdConfig: 0,
          IdCentro: action.centerId || null,
          NameOpening: null,
          startDate: null,
          isNewConfig: true,
          endDate: null,
          workDays: [],
          startWorkDay: null,
          endWorkDay: null,
          satWorkstart: null,
          satWorkEnd: null,
          sunWorkStart: null,
          sunWorkEnd: null,
          satWorking: false,
          sunWorking: false,
          moduleTime: null,
          priorityData: [],
          data: [],
          ExamPools: [], // baterias
          Exams: [],
          Ciel: [],
        },
      });
    }
    case "SET_QUOTES_LIST": {
      return Object.assign({}, state, {
        listQuotes: action.listQuotes,
      });
    }
    case "SET_VALIDATION_OPENING": {
      return Object.assign({}, state, {
        validationOpening: action.validationOpening,
      });
    }
    case "SET_DOWNLOAD_EXCEL_OPENING": {
      return Object.assign({}, state, {
        isDownloadExcel: action.isDownloadExcel,
      });
    }
    case "SET_OPEN_CONFLICT_OPEN": {
      return Object.assign({}, state, {
        isModalNameAndConflictOpen: action.isModalNameAndConflictOpen,
      });
    }
    case "RESET_STATES_OPENING": {
      return Object.assign({}, state, {
        isModalWizardLoading: false,
        centrosList: [],
        isOpenModalEditWeek: false,
        isOpenModalConflictWeek: false,
        isOpenModalDeleteOpening: false,
        idOpeningToDelete: null,
        appointment: {},
        appointmentEditWeek: {},
        feriadosAdministrativos: [],
        isDownloadExcel: false,
        isModalNameAndConflictOpen: false,
        centerId: null,
        centerConfig: {
          minWorkDay: null,
          maxWorkDay: null,
          minSatWork: null,
          maxSatWork: null,
          minSunWork: null,
          maxSunWork: null,
          listDaysWorking: [],
          listExamPools: [],
          listExams: [],
          listCiel: [],
        },
        validationOpening: {
          quotes: 0,
          openValidation: false,
          message: null,
        },
        configList: [],
        steps: {
          stepOne: true,
          stepTwo: false,
          stepThree: false,
          stepSuccess: false,
        },
        isBackStep: false,
        isPopupWizardOpen: false,
        configSchedulerWizard: {
          startDayHour: 9,
          endDayHour: 17,
          cellDuration: 30,
        },
        listaAppointments: null,
        weekAppointments: null,
        Opening: {
          Id: 0,
          IdConfig: null,
          IdCentro: null,
          isNewConfig: true,
          NameOpening: null,
          startDate: null,
          endDate: null,
          workDays: [],
          startWorkDay: null,
          endWorkDay: null,
          weekWorking: true,
          satWorkstart: null,
          satWorkEnd: null,
          sunWorkStart: null,
          sunWorkEnd: null,
          satWorking: false,
          sunWorking: false,
          moduleTime: null,
          priorityData: [],
          data: [],
          ExamPools: [],
          Exams: [],
          Ciel: [],
        },
        modulesConfig: [],
        listQuotes: [],
      })
    }

    default:
      return state;
  }
};

export default Reducer;
